module.exports = __webpack_public_path__ + "static/media/ico_whatsapp.f150551e.svg";